// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__Hrn+f","gradientFlow":"Banner_gradientFlow__2ND3Q","banner-content-wrapper":"Banner_banner-content-wrapper__y+fGP","close-icon":"Banner_close-icon__1wfH1"};